(() => {
  const STORAGE_PREFIX = 'mr-proof:';
  const EPOCH = Date.parse('2026-08-19T00:00:00+05:00');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const hash = (value) => {
    let total = 0;
    const text = String(value || '');
    for (let i = 0; i < text.length; i += 1) {
      total = (total * 31 + text.charCodeAt(i)) >>> 0;
    }
    return total;
  };

  const randomBetween = (min, max) => Math.round(min + Math.random() * (max - min));

  const readStore = (key) => {
    try {
      const raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  };

  const writeStore = (key, data) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(data));
    } catch (error) {
      /* ignore quota / private mode */
    }
  };

  const epochOffset = (handle, hours, divisor, jitter) => {
    const seeded = hash(handle) % jitter;
    return Math.max(0, Math.floor((hours + seeded * 0.17) / divisor));
  };

  const setNumber = (node, value, animate) => {
    if (!node || Number(node.textContent) === value) return;
    if (!animate || reduceMotion) {
      node.textContent = String(value);
      return;
    }

    node.classList.add('is-updating');
    window.setTimeout(() => {
      node.textContent = String(value);
      node.classList.remove('is-updating');
    }, 180);
  };

  const init = (root) => {
    if (!root || root.dataset.mrProofReady === 'true') return;
    root.dataset.mrProofReady = 'true';

    const soldNode = root.querySelector('[data-mr-sold]');
    const stockNode = root.querySelector('[data-mr-stock]');
    if (!soldNode && !stockNode) return;

    const handle = root.dataset.product || 'product';
    const storageKey = STORAGE_PREFIX + handle;
    const baseSold = Math.max(0, Number(root.dataset.sold) || 0);
    const baseStock = Math.max(0, Number(root.dataset.stock) || 0);
    const hours = Math.max(0, (Date.now() - EPOCH) / 3600000);
    const stockFloor = Math.max(16, Math.round(baseStock * 0.22));

    let sold = baseSold + epochOffset(handle + ':sold', hours, 3.6, 9);
    let stock = Math.max(stockFloor, baseStock - epochOffset(handle + ':stock', hours, 6.4, 13));

    const stored = readStore(storageKey);
    if (stored && Number.isFinite(stored.sold) && Number.isFinite(stored.stock)) {
      const elapsedMin = Math.max(0, (Date.now() - Number(stored.updatedAt || 0)) / 60000);
      sold = Math.max(sold, Number(stored.sold) + Math.min(10, Math.floor(elapsedMin / 24)));
      stock = Math.min(stock, Math.max(stockFloor, Number(stored.stock) - Math.min(6, Math.floor(elapsedMin / 38))));
    }

    const persist = () => writeStore(storageKey, { sold, stock, updatedAt: Date.now() });

    soldNode && (soldNode.textContent = String(sold));
    stockNode && (stockNode.textContent = String(stock));
    persist();

    if (root.dataset.live === 'false') return;

    let soldTimer;
    let stockTimer;
    let soldSession = 0;
    let stockSession = 0;
    let lastSoldAt = 0;
    let lastStockAt = 0;

    const staggerIfNeeded = (delay, otherAt) => {
      const nextAt = Date.now() + delay;
      if (otherAt && Math.abs(nextAt - otherAt) < 5000) {
        return delay + randomBetween(6000, 11000);
      }
      return delay;
    };

    const scheduleSold = (first) => {
      if (!soldNode || soldSession >= 5) return;
      const delay = staggerIfNeeded(randomBetween(first ? 14000 : 16000, first ? 32000 : 46000), lastStockAt);
      soldTimer = window.setTimeout(() => {
        sold += 1;
        soldSession += 1;
        lastSoldAt = Date.now();
        setNumber(soldNode, sold, true);
        persist();
        scheduleSold(false);
      }, delay);
    };

    const scheduleStock = (first) => {
      if (!stockNode || stock <= stockFloor || stockSession >= 4) return;
      const delay = staggerIfNeeded(randomBetween(first ? 26000 : 22000, first ? 52000 : 62000), lastSoldAt);
      stockTimer = window.setTimeout(() => {
        if (stock <= stockFloor) return;
        stock -= 1;
        stockSession += 1;
        lastStockAt = Date.now();
        setNumber(stockNode, stock, true);
        persist();
        scheduleStock(false);
      }, delay);
    };

    scheduleSold(true);
    scheduleStock(true);

    document.addEventListener(
      'visibilitychange',
      () => {
        if (document.hidden) {
          window.clearTimeout(soldTimer);
          window.clearTimeout(stockTimer);
        } else {
          scheduleSold(false);
          scheduleStock(false);
        }
      },
      { passive: true }
    );
  };

  document.querySelectorAll('[data-mr-proof]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mr-proof]').forEach(init);
  });
})();
